export default "__VITE_ASSET__Bg_o458P__"